import { useState } from "react";
import GridCompany from "../components/CompanyComponents/GridCompany/GridCompany.component";
import { Company } from "../utils/models/Company";
import CompanyForm from "../components/CompanyComponents/CompanyForm/CompanyForm.component";
import { useEffect } from 'react'
import { deleteCompany, getAllCompanies, newUpdateCompany } from "../utils/services/company.service";
import { useSelector } from "react-redux";
import { selectUser } from "./../utils/redux/userSlice";
import ModalComponent from "../components/ModalCompnent/modal.component";
import { useOutletContext } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { IOutletContext } from "../utils/interfaces/IOutletContext";
import { getAllInstalations } from "../utils/services/instalation.service";
import { Instalation } from "../utils/models/Instalation";
import { IToastProps, NotificationToast } from "aw-notificationtoast";
import { ButtonsLine } from "aw-management-buttons-line";
import { ISelectOptions } from "aw-combobox";
import { ROLES } from "aw-consts";
import {SearchPanel} from "aw-search-panel";

const CompaniesPage = () => {

    const [isNew, setIsNew] = useState(false)
    const [loading, setLoading] = useState(false)
    const [showModal, setShowModal] = useState(false)
    const [toast, setToast] = useState<IToastProps>({ showToast: false, msg: '', fail: false })
    const [newEditDelObj, setNewEditDelObj] = useState(new Company())
    const [companies, setCompanies] = useState<Company[]>([])
    const [allContainers, setAllContainers] = useState<Instalation[]>([])
    const [allContainersObj, setAllContainersObj] = useState<ISelectOptions[]>([])
    const [selectedContainers, setSelectedContainers] = useState<ISelectOptions[]>([])
    const [formLock, setFormLock] = useState(false)
    const [active, setActive] = useState(true)

    const user = useSelector(selectUser)

    const context: IOutletContext = useOutletContext();
    const { t } = useTranslation();

    useEffect(() => {
        context.setState(t('Companies'))
    })

    useEffect(() => {
        getAllCompaniesAux();
        getAllInstalationsAux();
    }, [])

    const showToastTimeOut = (msg: string, failToast: boolean) => {
        setToast({ showToast: true, msg: msg, fail: failToast })
        setTimeout(() => setToast({ showToast: false, msg: msg, fail: failToast }), 2000)
    }

    const newCompanyClick = () => {
        if (user.role === ROLES.Demo) {
            showToastTimeOut(t('noCreatePermissions'), true)
        } else {
            setSelectedContainers([])
            setFormLock(false)
            setIsNew(true)
            setActive(true)
        }
    }

    const getAllCompaniesAux = () => {
        setLoading(true)
        getAllCompanies(user.token).then((json) => {
            setCompanies(json)
        }).catch((e) => {
            showToastTimeOut(t('ErrorLoad'), true)
        }).finally(() => { setTimeout(() => { setLoading(false) }, 500) })
    }

    const getAllInstalationsAux = () => {
        getAllInstalations(user.token).then((json) => {
            setAllContainers(json)
            const containerobj = json.map((i: Instalation) => ({ label: i.name, value: i.idinstalation }))
            setAllContainersObj(containerobj)
        }).catch((e: any) => {
            console.error('getAllCanteensAux', e);
        })
    }

    const saveCompanyClick = () => {
        if(user.role === ROLES.Demo){
            showToastTimeOut(t('noEditPermissions'), true)
            return
        }
        const newArrayContainers: Instalation[] = []
        allContainers.forEach(i => {
            const container = selectedContainers.find(s => s.value === i.idinstalation);
            if (container) {
                newArrayContainers.push(i);
            }
        })

        newEditDelObj.instalations = newArrayContainers;
        newEditDelObj.active = active
        if (newEditDelObj.name.length !== 0) {
            newUpdateCompany(user.token, newEditDelObj).then((json) => {
                let c = []
                let msg = t('CreatedCompanyOK')

                if (newEditDelObj.idcompany > 0) {
                    msg = t('UpdatedCompanyOK')
                    const newCompanies = companies.filter((company) => company.idcompany !== json.idcompany);
                    c = [...newCompanies, json]
                } else { c = [...companies, json] }

                setCompanies(c)
                setIsNew(false)
                setNewEditDelObj(new Company())
                showToastTimeOut(msg, false)
            }
            ).catch(() => {
                setIsNew(false)
                setNewEditDelObj(new Company())
                showToastTimeOut(t('CompanyError'), true)
            }
            )
        } else {
            showToastTimeOut(t('RequireParams'), true)
        }
    }

    const cancelCompanyClick = () => {
        setIsNew(false)
        setNewEditDelObj(new Company())
    }

    const editCompanyClick = (c: Company) => {
        const newSelectedContainers = c.instalations.map((i) => ({ label: i.name, value: i.idinstalation }))
        setSelectedContainers(newSelectedContainers)
        setFormLock(true)
        setIsNew(true)
        setNewEditDelObj(c)
        setActive(c.active)
    }

    const deleteCompanyClick = (c: Company) => {
        if (user.role === ROLES.Demo) {
            showToastTimeOut(t('noDeletePermissions'), true)
        }
        else {
            setShowModal(true)
            setNewEditDelObj(c)
        }
    }

    const DesBloquearClick = () => {
        setFormLock(!formLock)
    }

    const onCompanyFormChange = (event: any) => {
        const { name, value } = event.target;
        if (name === 'active') {
            setActive(!active)

        } else {
            setNewEditDelObj((data: any) => ({
                ...data,
                [name]: value
            }));
        }
    }

    const ModalNo = () => {
        setShowModal(false)
    }

    const onSelectedImage = (img: string) => {
        setNewEditDelObj((data: any) => ({
            ...data,
            image: img
        }));

    }

    const ModalYes = () => {
        setShowModal(false)

        deleteCompany(user.token, newEditDelObj.idcompany).then((response) => {
            if (response.status >= 200 && response.status < 300) {
                const newCompanies = companies.filter((company) => company !== newEditDelObj);
                setCompanies(newCompanies);
                setNewEditDelObj(new Company())
                showToastTimeOut(t('DeleteCompanyOK'), false)
            } else { throw new Error() }
        }).catch(() => {
            setNewEditDelObj(new Company())
            showToastTimeOut(t('DeleteCompanyError'), true)
        })
    }
    const [globalFilter, setGlobalFilter] = useState<string>('');
    return (
        <>
            <NotificationToast showToast={toast.showToast} msg={toast.msg} fail={toast.fail} />
            <ModalComponent showModal={showModal} textDel={`${t('QuestionDelete')} ${newEditDelObj.name}?`} onClickNo={ModalNo} onClickYes={ModalYes} />
            <div className='row border-0 ms-2 me-2' style={{ maxWidth: '100%' }}>
                <div className='col-12 col-md-12 p-1'>
                    <ButtonsLine comboOptions={[]} onChangeSelected={() => { return null }} selectedOption={null} edit={isNew} viewMode={false} formLock={formLock} onClickNew={newCompanyClick} onClickSave={saveCompanyClick}
                        onClickCancel={cancelCompanyClick} onClickDesBloquear={DesBloquearClick} comboOptions2={[]} onChangeSelected2={() => { return null }} selectedOption2={null}
                        comboName="" comboName2="" classNameDanger="btn-Custom btn-IDRed" classNamePrimary="btn-Simple btn-Grey" classNameSuccess="btn-Custom btn-IDGreen" classNameNeutral="btn-Simple" saveText={t('Save')}
                        containerColor="var(--background-secondary)" rounded="rounded-1" dark={true} >
                           <SearchPanel searchAction={(query) => setGlobalFilter(query) } options={[]} value={[]} searchPlaceholder={t('Search')} onChange={function (value: (string | number)[]): void {
                            throw new Error("Function not implemented.");
                        } }/>
                            </ButtonsLine>
                </div>
            </div>
            <div className='row border-0 ms-2 me-2' style={{ maxWidth: '100%' }}>
                <div className='col-12 col-md-12 p-1'>
                    {isNew ? <CompanyForm edit={isNew} companyAux={newEditDelObj} sendChange={onCompanyFormChange}
                        formLock={formLock} options={allContainersObj}
                        selected={selectedContainers} onChangeSelect={setSelectedContainers} onSelectedFile={onSelectedImage} />
                        : <GridCompany companies={companies} onEditClick={editCompanyClick} onDeleteClick={deleteCompanyClick} loading={loading} onGlobalFilterChange={setGlobalFilter}  globalFilter={globalFilter}  />}
                </div>
            </div>
        </>
    )
}

export default CompaniesPage

